import { combineReducers } from 'redux'
import { Option } from '../constants/urls'
import {
  formatKIndexData,
  formatSpeedData,
  formatDensityData,
  formatBzData,
  adjustBz,
  getSpeedConversionMap,
  filterMagnetometer,
  getMagnetometerChange,
} from '../utils/parsers'

import {
  REQUEST_SPEED,
  RECEIVE_SPEED,
  ERROR_SPEED,
  RECEIVE_MAGNETOMETER,
  REQUEST_MAGNETOMETER,
  ERROR_MAGNETOMETER,
  REQUEST_BZ,
  RECEIVE_BZ,
  CREATE_ADJUSTED_BZ,
  ERROR_BZ,
  CHANGE_PERIOD,
  CHANGE_MAGNETOMETER,
} from '../actions'

import {
  RECEIVE_PREDICTED_K_INDEX,
  REQUEST_PREDICTED_K_INDEX,
  ERROR_PREDICTED_K_INDEX,
  RECEIVE_PREDICTED_3_DAY_K_INDEX,
  REQUEST_PREDICTED_3_DAY_K_INDEX,
  ERROR_PREDICTED_3_DAY_K_INDEX,
  REQUEST_K_INDEX,
  RECEIVE_K_INDEX,
  ERROR_K_INDEX,
} from '../actions/kIndex'

export interface AuroraAction {
  type: string
  data: any
  error: Error
  period: Option
  speedConversions: any
  magnetometer: any
  url: string
}

function predictedKIndex(state = { fetching: false }, action: AuroraAction) {
  switch (action.type) {
    case REQUEST_PREDICTED_K_INDEX:
      return {
        ...state,
        fetching: true,
      }
    case RECEIVE_PREDICTED_K_INDEX:
      return {
        ...state,
        fetching: false,
        data: action.data,
      }
    case ERROR_PREDICTED_K_INDEX:
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    default:
      return state
  }
}

function predicted3DayKIndex(state = { fetching: false }, action: AuroraAction) {
  switch (action.type) {
    case REQUEST_PREDICTED_3_DAY_K_INDEX:
      return {
        ...state,
        fetching: true,
      }
    case RECEIVE_PREDICTED_3_DAY_K_INDEX:
      return {
        ...state,
        fetching: false,
        data: action.data,
      }
    case ERROR_PREDICTED_3_DAY_K_INDEX:
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    default:
      return state
  }
}

function kIndex(state = { fetching: false, data: {} }, action: AuroraAction) {
  switch (action.type) {
    case REQUEST_K_INDEX:
      return {
        ...state,
        fetching: true,
      }
    case RECEIVE_K_INDEX:
      return {
        ...state,
        fetching: false,
        error: false,
        ...formatKIndexData(action.data),
      }
    case ERROR_K_INDEX:
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    default:
      return state
  }
}

function speed(state = { fetching: true, data: {} }, action: AuroraAction) {
  switch (action.type) {
    case REQUEST_SPEED:
      return {
        ...state,
        fetching: true,
      }
    case RECEIVE_SPEED:
      return {
        ...state,
        fetching: false,
        error: false,
        ...formatSpeedData(action.data),
        speedConversions: getSpeedConversionMap(action.data),
      }
    case ERROR_SPEED:
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    default:
      return state
  }
}

function magnetometers(state = { fetching: true, data: {} }, action: AuroraAction) {
  switch (action.type) {
    case REQUEST_MAGNETOMETER:
      return {
        ...state,
        fetching: true,
      }
    case RECEIVE_MAGNETOMETER:
      return {
        ...state,
        fetching: false,
        error: false,
        data: action.data,
        periodData: action.data.map((data: any) => {
          return {
            key: data.key,
            data: filterMagnetometer(data.data, action.period),
            change: getMagnetometerChange(data.data),
          }
        }),
      }
    case ERROR_MAGNETOMETER:
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    default:
      return state
  }
}

function bZ(state = { fetching: true, data: {} }, action: AuroraAction) {
  switch (action.type) {
    case REQUEST_BZ:
      return {
        ...state,
        fetching: true,
      }
    case RECEIVE_BZ:
      return {
        ...state,
        fetching: false,
        ...formatBzData(action.data),
      }
    case CREATE_ADJUSTED_BZ:
      return {
        ...state,
        ...adjustBz(action.data, action.speedConversions),
      }
    case ERROR_BZ:
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    default:
      return state
  }
}

function density(state = { fetching: true, data: {} }, action: AuroraAction) {
  switch (action.type) {
    case RECEIVE_SPEED:
      return {
        ...state,
        fetching: false,
        error: false,
        ...formatDensityData(action.data),
      }
    case ERROR_SPEED:
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    default:
      return state
  }
}

function currentTime() {
  return new Date()
}

function period(state: Option = 6, action: AuroraAction) {
  switch (action.type) {
    case CHANGE_PERIOD:
      return action.period
    default:
      return state
  }
}

function selectedMagnetometer(state = 'nur', action: AuroraAction) {
  switch (action.type) {
    case CHANGE_MAGNETOMETER:
      return action.magnetometer
    default:
      return state
  }
}

const rootReducer = combineReducers({
  predictedKIndex,
  predicted3DayKIndex,
  kIndex,
  speed,
  magnetometers,
  density,
  bZ,
  currentTime,
  period,
  selectedMagnetometer,
})

export default rootReducer
